import { Column } from '../../../model/table';
import { ActivityDto } from '../../../dtos/activity.dto';
import CustomIcon, { IconType } from '../../shared/custom-icon/custom-icon';

export const activityColumns: Column<ActivityDto>[] = [
    {
        accessor: 'auditTimestamp',
        header: 'Date & Time',
        width: 250,
    },
    {
        accessor: 'activity',
        header: 'Activity',
        width: 250
    },
    {
        accessor: 'policyVersion',
        header: 'Version',
        width: 150
    },
    {
        accessor: 'updatedBy',
        header: 'User',
        width: 250,
        getDisplayElement: (column, row) => {
            const user = row[column.accessor];
            const { updatedBySource } = row;
            return updatedBySource === 'ATT' ? <div className={'activity-user'}><CustomIcon type={IconType.APPLY_ATT}/>AT&T</div> : user;
        }
    },
    {
        accessor: 'clientIp',
        header: 'Client IP',
        width: 250
    },
];
